import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/Button';

interface UnknownEmailStepProps {
  email: string;
  onBack: () => void;
}

export const UnknownEmailStep = ({ email, onBack }: UnknownEmailStepProps) => {
  const { t } = useTranslation('app');

  return (
    <div className="grid gap-4 max-w-md mx-auto">
      <p className="notice warning">{t('login.unknownEmail', { email })}</p>
      <Button color="neutral" fullWidth onClick={onBack} variant="outline">
        <span className="inline-flex items-center gap-1">
          <ArrowLeft aria-hidden size={14} />
          {t('login.back')}
        </span>
      </Button>
    </div>
  );
};
